import { SPECIAL_HEADER, type HeaderFxParameter } from '!/api/index.h'
import { LocalStorageKey } from '@/constants'

type GuestRegionHeadersParams = {
  isNotAuthenticated: boolean
  regionId?: number | null
}

export function getPrimaryRegionIdFromStorage(): number | null {
  const region = window.localStorage.getItem(LocalStorageKey.PrimaryRegion)

  return region ? (JSON.parse(region)?.primaryRegion?.id ?? null) : null
}

// Set header only if guest has selected the region
export function buildGuestRegionHeaders({
  isNotAuthenticated,
  regionId,
}: GuestRegionHeadersParams): HeaderFxParameter {
  if (!isNotAuthenticated || !regionId) {
    return { headers: {} }
  }

  return {
    headers: {
      [SPECIAL_HEADER.CLIENT_PRIMARY_REGION]: String(regionId),
    },
  }
}
